module.exports = __webpack_public_path__ + "img/anid.2e047aa0.png";